// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TReadMessagesModel, IMappers, TReadMessagesResponse, TReadMessagesResponseData200 } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createReadMessagesModel(): TReadMessagesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-chat-bot',
    pathApi: '/v1/read-messages/',
    response: {
      '200': {},
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IReadMessagesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchReadMessages<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IReadMessagesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TReadMessagesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createReadMessagesModel(),
    config,
  )) as FetchResponse<TReadMessagesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TReadMessagesResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TReadMessagesResponse>;
}
